/* How long the chat waits for Clara's /query before it stops and says so. Set
   REACT_APP_CLARA_QUERY_TIMEOUT_MS in env-config.js, like the other Clara settings. Longer
   than Clara's own 25 second question deadline, so her plain message normally arrives
   first and this only catches a reply that never comes. */
export const CLARA_QUERY_TIMEOUT_MS = Number(window.env?.REACT_APP_CLARA_QUERY_TIMEOUT_MS) || 35000

export const CLARA_TIMEOUT_MESSAGE = "I didn’t get an answer in time. Please ask again in a moment."

export async function fetchWithTimeout(url, options = {}, ms = CLARA_QUERY_TIMEOUT_MS) {
	const controller = new AbortController()
	const timer = setTimeout(() => controller.abort(), ms)
	try {
		return await fetch(url, { ...options, signal: controller.signal })
	} finally {
		clearTimeout(timer)
	}
}

export const isTimeout = error => error?.name === "AbortError"
